import React, { CSSProperties, FC } from 'react';
import { Button, Space } from 'antd';
import { Formik } from 'formik';
import { Form, Input, SubmitButton } from 'formik-antd';
import { FormikOnSubmit } from 'lib/formik.utils';
import { SearchOutlined } from '@ant-design/icons/lib';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { FormattedMessage } from 'react-intl';
import { SubpartnersFilterSelect } from 'common/components/SubpartnersSelect';

export interface PatientsFiltersFormModel {
  firstName?: string;
  lastName?: string;
  partnerId?: number;
}

export interface PatientsFiltersProps {
  loading?: boolean;
  value?: PatientsFiltersFormModel;
  onSubmit: FormikOnSubmit<PatientsFiltersFormModel>;
  style?: CSSProperties;
  partnerHardcoded?: string;
  shouldHidePartnerColumn: boolean;
}

export const PatientsFilters: FC<PatientsFiltersProps> = ({
  onSubmit,
  loading,
  partnerHardcoded,
  value = {},
  style,
  shouldHidePartnerColumn,
}) => {
  const intlMessage = useFormatMessage();

  return (
    <Formik initialValues={value} onSubmit={onSubmit} onReset={onSubmit}>
      <Form style={style}>
        <Space style={{ marginBottom: '1rem' }}>
          <Input
            name="firstName"
            placeholder={intlMessage({ id: 'person.firstName' })}
            style={{ width: 200 }}
          />
          <Input
            name="lastName"
            placeholder={intlMessage({ id: 'person.lastName' })}
            style={{ width: 200 }}
          />
          {!shouldHidePartnerColumn && (
            <SubpartnersFilterSelect
              name="partnerId"
              placeholder={intlMessage({ id: 'partner' })}
              style={{ minWidth: 200, width: '100%' }}
              value={partnerHardcoded && partnerHardcoded}
              disabled={partnerHardcoded ? true : false}
            />
          )}
          <SubmitButton
            type="default"
            loading={loading}
            icon={<SearchOutlined />}
          >
            <FormattedMessage id="search" tagName="span" />
          </SubmitButton>
          <Button id="button-clear-patients-filter" htmlType="reset">
            <FormattedMessage id="clear" />
          </Button>
        </Space>
      </Form>
    </Formik>
  );
};
